import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "محول مقاسات الملابس والأحذية العالمي - تحويل مقاسات النساء والرجال والأطفال";
const DESCRIPTION =
  "أدق محول مقاسات ملابس وأحذية عالمي. تحويل مقاسات الفساتين، البناطيل، والقمصان بين الأنظمة الأمريكية، الأوروبية، البريطانية، والإيطالية للنساء والرجال والأطفال بدقة عالية.";
const KEYWORDS =
  "محول مقاسات الملابس, تحويل مقاس الفساتين, مقاسات الأحذية العالمية, جدول مقاسات النساء, تحويل مقاسات الرجال, مقاسات الأطفال, تحويل مقاسات البناطيل, حاسبة مقاسات الملابس, مقاسات شي ان, مقاسات امازون";
const OG_URL = "https://do-calculate.com/calculator/ar/clothing-size-converter/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "محول مقاسات الملابس والأحذية العالمي",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "محول مقاسات الملابس",
        item: OG_URL,
      },
    ],
  },
];

const SIZES_DATA = {
  women_dresses: [
    { us: "0", uk: "2", eu: "30", italy: "36", int: "XXS" },
    { us: "2", uk: "4", eu: "32", italy: "38", int: "XS" },
    { us: "4", uk: "6", eu: "34", italy: "40", int: "S" },
    { us: "6", uk: "8", eu: "36", italy: "42", int: "S" },
    { us: "8", uk: "10", eu: "38", italy: "44", int: "M" },
    { us: "10", uk: "12", eu: "40", italy: "46", int: "M" },
    { us: "12", uk: "14", eu: "42", italy: "48", int: "L" },
    { us: "14", uk: "16", eu: "44", italy: "50", int: "L" },
    { us: "16", uk: "18", eu: "46", italy: "52", int: "XL" },
  ],
  men_suits: [
    { us: "34", uk: "34", eu: "44", italy: "44", int: "XS" },
    { us: "36", uk: "36", eu: "46", italy: "46", int: "S" },
    { us: "38", uk: "38", eu: "48", italy: "48", int: "M" },
    { us: "40", uk: "40", eu: "50", italy: "50", int: "M" },
    { us: "42", uk: "42", eu: "52", italy: "52", int: "L" },
    { us: "44", uk: "44", eu: "54", italy: "54", int: "L" },
    { us: "46", uk: "46", eu: "56", italy: "56", int: "XL" },
  ],
  men_pants: [
    { us: "28", uk: "28", eu: "38", italy: "42", int: "S" },
    { us: "30", uk: "30", eu: "40", italy: "44", int: "S" },
    { us: "32", uk: "32", eu: "42", italy: "46", int: "M" },
    { us: "34", uk: "34", eu: "44", italy: "48", int: "M" },
    { us: "36", uk: "36", eu: "46", italy: "50", int: "L" },
    { us: "38", uk: "38", eu: "48", italy: "52", int: "L" },
    { us: "40", uk: "40", eu: "50", italy: "54", int: "XL" },
  ],
  women_shoes: [
    { us: "5", uk: "3", eu: "35", italy: "35", int: "35" },
    { us: "6", uk: "4", eu: "36", italy: "36", int: "36" },
    { us: "7", uk: "5", eu: "37", italy: "37", int: "37" },
    { us: "8", uk: "6", eu: "38", italy: "38", int: "38" },
    { us: "9", uk: "7", eu: "39", italy: "39", int: "39" },
    { us: "10", uk: "8", eu: "40", italy: "40", int: "40" },
    { us: "11", uk: "9", eu: "41", italy: "41", int: "41" },
  ],
  men_shoes: [
    { us: "7", uk: "6", eu: "40", italy: "40", int: "40" },
    { us: "8", uk: "7", eu: "41", italy: "41", int: "41" },
    { us: "9", uk: "8", eu: "42", italy: "42", int: "42" },
    { us: "10", uk: "9", eu: "43", italy: "43", int: "43" },
    { us: "11", uk: "10", eu: "44", italy: "44", int: "44" },
    { us: "12", uk: "11", eu: "45", italy: "45", int: "45" },
    { us: "13", uk: "12", eu: "46", italy: "46", int: "46" },
  ],
  children_clothing: [
    { us: "2T", uk: "2", eu: "92", italy: "92", int: "XS" },
    { us: "3T", uk: "3", eu: "98", italy: "98", int: "S" },
    { us: "4T", uk: "4", eu: "104", italy: "104", int: "M" },
    { us: "5", uk: "5", eu: "110", italy: "110", int: "M" },
    { us: "6", uk: "6", eu: "116", italy: "116", int: "L" },
    { us: "7", uk: "7", eu: "122", italy: "122", int: "L" },
    { us: "8", uk: "8", eu: "128", italy: "128", int: "XL" },
  ],
};

function ClothingSizeConverter() {
  const [category, setCategory] = useState("women_dresses");
  const [inputSystem, setInputSystem] = useState("us");
  const [inputValue, setInputValue] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleCalculate = () => {
    setError("");
    if (!inputValue) {
      setResult(null);
      return;
    }

    const currentCategoryData = SIZES_DATA[category];
    const sizeData = currentCategoryData.find(
      (s) => String(s[inputSystem]).toLowerCase() === String(inputValue).toLowerCase()
    );

    if (sizeData) {
      setResult(sizeData);
    } else {
      setResult(null);
      if (inputValue !== "") {
        setError("المقاس المدخل غير موجود في قاعدة بيانات هذا النوع.");
      }
    }
  };

  useEffect(() => {
    handleCalculate();
  }, [category, inputSystem, inputValue]);

  const handleClear = () => {
    setCategory("women_dresses");
    setInputSystem("us");
    setInputValue("");
    setResult(null);
    setError("");
  };

  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>محول مقاسات الملابس والأحذية العالمي</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                يعتبر <strong>محول مقاسات الملابس</strong> أداة لا غنى عنها عند التسوق عبر الإنترنت من المتاجر العالمية مثل شي ان، امازون، أو علي اكسبرس. تختلف أنظمة القياس بشكل كبير بين الدول؛ فالمقاس الأمريكي (US) يختلف عن البريطاني (UK) والأوروبي (EU). تساعدك هذه الحاسبة في تحويل مقاسك بدقة لضمان اختيار القطعة المناسبة لك ولعائلتك.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  أداة تحويل المقاسات الذكية
                </h2>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6 mb-3">
                  <label >الفئة (نساء، رجال، أطفال)</label>
                  <select
                    className="form-select"
                    value={category}
                    onChange={(e) => {
                      setCategory(e.target.value);
                      setResult(null);
                    }}
                  >
                    <optgroup label="قسم النساء">
                      <option value="women_dresses">فساتين، بلايز، وملابس علوية</option>
                      <option value="women_shoes">أحذية نسائية</option>
                    </optgroup>
                    <optgroup label="قسم الرجال">
                      <option value="men_suits">بدلات، قمصان، وجاكيتات</option>
                      <option value="men_pants">بناطيل وجينز رجالي</option>
                      <option value="men_shoes">أحذية رجالية</option>
                    </optgroup>
                    <optgroup label="قسم الأطفال">
                      <option value="children_clothing">ملابس الأطفال (مقاسات عالمية)</option>
                    </optgroup>
                  </select>
                </div>
                <div className="col-sm-12 col-md-6 mb-3">
                  <label >نظام المقاس الحالي</label>
                  <select
                    className="form-select"
                    value={inputSystem}
                    onChange={(e) => {
                      setInputSystem(e.target.value);
                      setResult(null);
                    }}
                  >
                    <option value="us">الأمريكي (US)</option>
                    <option value="uk">البريطاني (UK)</option>
                    <option value="eu">الأوروبي (EU / Middle East)</option>
                    <option value="italy">الإيطالي (Italy)</option>
                  </select>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-sm-12">
                  <label >أدخل المقاس الرقمي</label>
                  <input
                    type="text"
                    className="form-control"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="مثال: 8 أو 40 أو 2T"
                  />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  إعادة ضبط
                </button>
              </div>

              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>نعتذر:</strong> {error}
                </div>
              )}

              {result && (
                <div className="mt-4">
                  <h3
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    <strong>جدول المقاسات المقابلة:</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>المعيار الدولي</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>المقاس المعادل</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>النظام الأمريكي (US)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.us}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>النظام البريطاني (UK)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.uk}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>النظام الأوروبي (EU)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.eu}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>النظام الإيطالي (Italy)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.italy}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center", backgroundColor: "#f8f9fa" }}>المقاس العالمي (Letters)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold", color: "#1a5f3f", backgroundColor: "#f8f9fa" }}>{result.int}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>نصيحة التسوق الذكي</strong>
                      </div>
                      <div className="info-section-body">
                        <p style={{ lineHeight: "1.6", fontSize: "14px", margin: 0 }}>
                          عند الشراء من ماركات مثل <strong>Zara</strong> أو <strong>H&M</strong>، يفضل الاعتماد على النظام الأوروبي (EU). أما عند الشراء من ماركات رياضية مثل <strong>Nike</strong> أو <strong>Adidas</strong>، فالمقاس الأمريكي (US) هو الأكثر دقة.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>أهمية استخدام محول مقاسات الملابس عند التسوق أونلاين</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  التسوق الإلكتروني يوفر خيارات غير محدودة، لكن العائق الأكبر دائماً هو "المقاس المناسب". استخدام <strong>جدول مقاسات الملابس</strong> الصحيح يحميك من:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>خسارة المال:</strong> تكاليف الشحن والإرجاع قد تكون مرتفعة.</li>
                  <li><strong>تضييع الوقت:</strong> انتظار شحنة لأسابيع ثم اكتشاف أنها غير مناسبة أمر محبط.</li>
                  <li><strong>عدم تناسق المظهر:</strong> الملابس التي لا تناسب مقاسك بدقة تؤثر على مظهرك النهائي وثقتك بنفسك.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>دليل تحويل مقاسات الأحذية (الرجال والنساء)</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  مقاسات الأحذية تختلف جذرياً بين الأنظمة. على سبيل المثال، المقاس الأوروبي 42 للرجال يعادل تقريباً المقاس 9 في النظام الأمريكي. في عالمنا العربي، نعتمد بشكل أساسي على النظام الأوروبي (EU). إذا كنت تشتري من موقع أمريكي، تأكد من استخدام <strong>محول مقاسات الأحذية</strong> الخاص بنا لتفادي اختيار حذاء ضيق أو واسع جداً.
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>مقاسات الأطفال: كيفية الاختيار الصحيح؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تعتمد مقاسات الأطفال في الغالب على العمر (مثل 2T لسن سنتين)، لكن نمو الأطفال يختلف من طفل لآخر. النظام الأوروبي يعتمد على طول الطفل بالسنتيمتر (مثل مقاس 92 للطفل الذي طوله 92 سم). حاسبتنا تدمج هذه الأنظمة لتسهيل المهمة على الأمهات والآباء عند شراء ملابس الأطفال من الخارج.
                </p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <strong>أسئلة شائعة حول مقاسات الملابس</strong>
              </div>
              <div className="info-section-body">
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>س: ماذا يعني مقاس S و M و L؟</strong><br />ج: هي اختصارات عالمية (Small, Medium, Large) وتستخدم غالباً في الملابس الرياضية والتيشرتات التي تعتمد على مرونة القماش.</li>
                  <li><strong>س: هل مقاسات الملابس الإيطالية أصغر من المعتاد؟</strong><br />ج: نعم، غالباً ما تكون القصات الإيطالية (Slim Fit) أصغر وأضيق مقارنة بالمقاسات الأمريكية التي تمتاز بالوسع.</li>
                  <li><strong>س: كيف أقيس محيط الصدر والخصر؟</strong><br />ج: استخدم شريط قياس مرن، وقم بلفه حول أوسع منطقة في الصدر وأضيق منطقة في الخصر للحصول على أدق النتائج قبل مقارنتها بجدول المقاسات.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClothingSizeConverter;